var _defs, _polygon, _polygon2, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.32 30.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fcb116;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.01 17.48 15.63 16.12 16.98 15.51 15.63 14.89 15.01 13.53 14.39 14.89 13.04 15.51 14.39 16.12 15.01 17.48"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.01 20.44 14.39 21.8 13.04 22.42 14.39 23.03 15.01 24.39 15.63 23.03 16.98 22.42 15.63 21.8 15.01 20.44"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.87,27.23l-1.23-2.72L20.4,27.23l-2.72,1.23L20.4,29.7l1.23,2.72,1.23-2.72,2.72-1.23ZM22.13,29,21.64,30,21.15,29l-1.08-.49L21.15,28l.49-1.08L22.13,28l1.08.49Z",
    transform: "translate(-11.56 -9.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.76,9.5H14.6a3,3,0,0,0-3,3l0,24.32a3,3,0,0,0,3,3H32.84a3,3,0,0,0,3-3V18.63ZM14.6,36.87V12.55H25.24v7.6h7.6V36.87Z",
    transform: "translate(-11.56 -9.5)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.8ea240a71fa4570f48b2c45aa0a678ed.svg";
export { ForwardRef as ReactComponent };